import { useEffect } from "react";

/* A one-off burst for the moment a new instance's overlay first connects.

   Pure CSS, a couple of dozen spans, gone in under two seconds, and not drawn
   at all for anyone who asked for less motion — the toast that goes with it
   carries the actual message. */
const COLORS = ["var(--accent)", "var(--ok)", "var(--warn)", "var(--error)"];

export function Celebration({ onDone }: { onDone: () => void }) {
  useEffect(() => {
    const timer = window.setTimeout(onDone, 1800);
    return () => window.clearTimeout(timer);
  }, [onDone]);

  return (
    <div className="celebration" aria-hidden="true">
      {Array.from({ length: 28 }, (_, index) => (
        <span
          key={index}
          style={{
            left: `${(index * 37) % 100}%`,
            background: COLORS[index % COLORS.length],
            animationDelay: `${(index % 7) * 60}ms`,
            ["--drift" as string]: `${((index * 53) % 120) - 60}px`,
            ["--spin" as string]: `${(index * 97) % 360}deg`,
          }}
        />
      ))}
    </div>
  );
}
